import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconShoppingBag: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3334 4.83333H10.8334V4.33333C10.8334 2.77067 9.56275 1.5 8.00008 1.5C6.43741 1.5 5.16675 2.77067 5.16675 4.33333V4.83333H3.66675C2.84008 4.83333 2.16675 5.506 2.16675 6.33333V12C2.16675 13.612 3.05475 14.5 4.66675 14.5H11.3334C12.9454 14.5 13.8334 13.612 13.8334 12V6.33333C13.8334 5.506 13.1601 4.83333 12.3334 4.83333ZM6.16675 4.33333C6.16675 3.322 6.98875 2.5 8.00008 2.5C9.01141 2.5 9.83341 3.322 9.83341 4.33333V4.83333H6.16675V4.33333ZM12.8334 12C12.8334 13.0513 12.3847 13.5 11.3334 13.5H4.66675C3.61541 13.5 3.16675 13.0513 3.16675 12V6.33333C3.16675 6.05733 3.39141 5.83333 3.66675 5.83333H5.16675V7.33333C5.16675 7.60933 5.39075 7.83333 5.66675 7.83333C5.94275 7.83333 6.16675 7.60933 6.16675 7.33333V5.83333H9.83341V7.33333C9.83341 7.60933 10.0574 7.83333 10.3334 7.83333C10.6094 7.83333 10.8334 7.60933 10.8334 7.33333V5.83333H12.3334C12.6087 5.83333 12.8334 6.05733 12.8334 6.33333V12Z"
      fill={color}
    />
  </svg>
);

export default IconShoppingBag;
